<template>
    <router-view v-if="ready"/>
</template>

<script>
import PortalAuth from '@/service/portalAuth';
import ApiService from "@/service/apiService";
import {accessRights} from '@/service/accessRights.js';

export default {
    data:function(){
        return {
            portalUserId: null,
            portalCred: null,
            userAccessRights: null,
            userAccessRightsTree: null,
            securityModel: null,
            ready: false,
            agisAdminKey: null,
        }
    },
    created: function() {
        this.loadAccessRight();
    },
    mounted:function(){
        var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        if(isIE11){
            delete window.PointerEvent;
            window.navigator.msPointerEnabled = false;
        }
    },
    methods: {
        loadAccessRight: function() {
            var portalAuth = new PortalAuth();
            var loginResult = portalAuth.loginPortal()
            loginResult.then((r) => {
                this.portalUserId = r.userId
                this.portalCred = r;
                window.sessionStorage.setItem("portalUserId", r.userId);
                var apiService = new ApiService()
                apiService.getAccessRights(
                    this.portalUserId, 
                    [],
                    (r)=>{
                        this.userAccessRights = r;
                        this.isAGISAdmin = this.checkIsAdmin();
                        this.ready = true;
                    },
                    (e)=>{
                        console.log('Exception', e);
                    }
                );
            });
            return;
        },
        checkIsAdmin: function() {
            for (var index in this.userAccessRights.user_system_levels) {
                var user_system_level = this.userAccessRights.user_system_levels[index];
                if (user_system_level.name == 'AGIS_ADMIN' && user_system_level.level >= 3) {
                    return true;
                }
            }
        },
        hasAccessRight: function(subsystemCode, minLevel, systemAdminCode) {
            return this.getAccessLevel(subsystemCode, systemAdminCode) >= minLevel;
        },
        getAccessLevel: function(subsystemCode, systemAdminCode) {
            var level = 0;
            var agisAdminChecked = false;
            var systemAdminChecked = false;
            if (subsystemCode == null) {
                level = 4;
            } else {
                for (var index in this.userAccessRights.user_system_levels) {
                    var user_system_level = this.userAccessRights.user_system_levels[index];
                    if (user_system_level.name == 'AGIS_ADMIN') {
                        agisAdminChecked = true;
                        if (user_system_level.level >= 3) {
                            return 4;
                        }else{
                            user_system_level.level=1;
                        }
                    } else if (systemAdminCode && user_system_level.name == systemAdminCode) {
                        systemAdminChecked = true;
                        if (user_system_level.level >= 4) {
                            level = 4;
                            break;
                        }else{
                            user_system_level.level=1;
                        }
                    } else if (user_system_level.name == subsystemCode) {
                        level = user_system_level.level;
                        if (agisAdminChecked && systemAdminChecked) {
                            break;
                        }
                    }
                }
                return level;
            }
            if(systemAdminCode=='AGIS_ADMIN'){
                return 1;
            }
            return 0;
        }
    }
}
</script>

<style>
/* esri styles */
/* @import url('https://js.arcgis.com/4.7/esri/themes/dark/main.css'); */
@import url('https://js.arcgis.com/4.9/esri/themes/dark/main.css');
/* @import url('https://js.arcgis.com/4.10/esri/themes/dark/main.css'); */ /*may be bug*/

@media (max-width: 767.98px) {
    .main-content{
        max-height: 100%;
        object-fit: contain;
        /* background-color: red !important; */
    }
}

.copy-right{
    color: black;
}

.main-content{
    width: 100%;
    /* height: calc(100vh - 80px); */
    height: 100%;
    min-height: calc(100vh - 80px);

    /* Old browsers */
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#f0f9ff+0,cbebff+47,a1dbff+100;Blue+3D+%2313 */
    background-repeat: round;
    background: #258dc8;
    /* FF3.6-15 */
    background: -moz-linear-gradient(top, #258dc8 0%, #cbebff 47%, #f0f9ff 100%); 
    /* Chrome10-25,Safari5.1-6 */
    background: -webkit-linear-gradient(top, #258dc8 0%,#cbebff 47%,#f0f9ff 100%); 
    /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    background: linear-gradient(to bottom, #258dc8 0%,#cbebff 47%,#f0f9ff 100%); 
    /* IE6-9 */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#258dc8', endColorstr='#f0f9ff',GradientType=0 ); 

}

.popover .vdp-datepicker{
    color:black;
}

.popover .vdp-datepicker__calendar {
    right: 0px;
}

.popover .vdp-datepicker__clear-button{
    color:white;
}

.map{
    -ms-touch-action: none;
    -ms-touch-select: none;
    -ms-user-select: none;
}

/*when a desktop navigation bar link is in-active*/
.nav-pills .nav-link{
    color: #00bc8c
}

/*when a mobile navigation bar link is active*/
.navbar-dark .navbar-nav .nav-link.active{
    color: #00bc8c  
}

/*fix jsapi 4.7 detail table*/
.esri-view .esri-view-user-storage{
    /* overflow: initial; */
    background-color: transparent;
    /* 20180809 Jason LI */
    width:100%;
    height: 100%;
    position: absolute;
    pointer-events: none;
    overflow-y: hidden;
    overflow-x:auto;
    left:0;
}

/* 20180809 Jason LI */
.esri-view .esri-view-user-storage div{
    pointer-events: auto;
}

.map-detail-table{
    background-color:black;
    width:500px;
    overflow-y:auto;
    right: 0;
    position: absolute;
}
/* 20180809 end Jason LI */


/*fix jsapi 4.7 expand legend*/
.esri-ui-corner .esri-expand .esri-legend.esri-widget--panel{
    width:auto;
}

.modal-dialog .table-responsive{
    max-height: calc(100vh - 270px);
    overflow-y: auto;
}

.calc-modal-height .modal-body{
    max-height: calc(100vh - 170px);
    overflow-x: hidden;
    margin-bottom:0px;
} 
.calc-modal-height .modal-dialog{
    margin-bottom:0px;
}

.calc-modal-height-with-footer .modal-body{
    max-height: calc(100vh - 190px);
    overflow-x: hidden;
} 
.calc-modal-height-with-footer .modal-dialog{
    margin-bottom:0px;
}

.calc-modal-height .modal{
    padding:0px;
} 

.calc-modal-height-with-footer .modal{
    padding:0px;
} 

#default-details-table th, #default-details-table td{
    white-space:nowrap;
}

/*fix search widget result and expand widget*/
.esri-search--show-suggestions .esri-search__suggestions-menu, .esri-search--sources .esri-search__sources-menu{
    z-index: 9999;
}

.full-width-b-modal .modal-dialog{
    max-width:100vw !important;
}

/* 20180711 Jason LI */
.aa-logo{
    width:128px;
    height: 66px;
}
.overflow-x-hidden{
    overflow-x:hidden;
}

.navbar{
    padding: 0rem 1rem;
}

.card-img-top{
    height:175px;
    width:318px;
}

.banner-home,.banner-home:hover{
    color:white;
}

.affected-result-title{
    padding-left: 15px;
    padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue